<div>
  <nz-spin [nzSpinning]="isLoading">
    <form nz-form (ngSubmit)="projectInformationSubmit()" class="form-container" [formGroup]="projectInfoControl">
      <nz-form-item>
        <nz-form-label nzRequired>Project Name</nz-form-label>
        <nz-form-control nzErrorTip="Please input Project Name">
          <nz-input-group>
            <input type="text" nz-input formControlName="name" placeholder="Project Name" />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Project Description</nz-form-label>
        <nz-form-control>
          <nz-input-group>
            <textarea type="text" nz-input formControlName="description" placeholder="Project Description"></textarea>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Project Field</nz-form-label>
        <nz-form-control nzErrorTip="Please Select Field!">
          <nz-input-group>
            <!-- <input type="text" nz-input formControlName="username" placeholder="Username" /> -->
            <nz-select id="field" formControlName="field" nzPlaceHolder="Select Field" [compareWith]="fieldCompareFn">
              @for (field of fields; track field) {
                <nz-option [nzValue]="field" [nzLabel]="field.name"></nz-option>
              }
            </nz-select>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <!-- Display Variables Section -->
      <nz-form-item>
        <nz-form-label>Model Display Defaults</nz-form-label>
        <nz-form-control>
          <div class="display-variables-section">
            <div class="section-header">
              <span>Set default min/max display values for each model type</span>
              <button nz-button nzType="dashed" nzSize="small" type="button" (click)="addDisplayVariable()">
                <span nz-icon nzType="plus"></span> Add Model Type
              </button>
            </div>

            <div formArrayName="displayVariables" class="display-variables-list">
              @for (displayVar of displayVariablesFormArray.controls; track displayVar; let i = $index) {
                <div [formGroupName]="i"
                  class="display-variable-row">
                  <nz-form-item class="model-type-field">
                    <nz-form-control
                      [nzValidateStatus]="displayVar.get('modelType')?.invalid && displayVar.get('modelType')?.touched ? 'error' : ''"
                      [nzErrorTip]="displayVar.get('modelType')?.hasError('required') ? 'Model type is required' : ''">
                      <nz-select formControlName="modelType" nzPlaceHolder="Select or type model type" nzShowSearch
                        nzAllowClear [nzFilterOption]="false" (nzOnSearch)="onModelTypeSearch($event)">
                        @for (type of filteredModelTypes; track type) {
                          <nz-option [nzValue]="type" [nzLabel]="type"></nz-option>
                        }
                      </nz-select>
                    </nz-form-control>
                  </nz-form-item>
                  <!-- For zero-centered types -->
                  @if (isZeroCentered(displayVar.get('modelType')?.value)) {
                    <nz-form-item class="single-value-field">
                      <nz-form-control [nzValidateStatus]="displayVar.hasError('singleValueError') ? 'error' : ''"
                        [nzErrorTip]="displayVar.hasError('singleValueError') ? 'Value must be greater than 0' : 'Sets range to ±value'">
                        <nz-input-group nzPrefix="Value (±):">
                          <input type="number" noScrollNumber nz-input formControlName="singleValue" placeholder="Value"
                            step="any" />
                        </nz-input-group>
                      </nz-form-control>
                    </nz-form-item>
                    <nz-form-item class="spacer-field"></nz-form-item>
                  }
                  @if (!isZeroCentered(displayVar.get('modelType')?.value)) {
                    <nz-form-item class="min-value-field">
                      <nz-form-control [nzValidateStatus]="displayVar.hasError('minMaxError') ? 'error' : ''"
                        [nzErrorTip]="displayVar.hasError('minMaxError') ? 'Min must be less than max' : ''">
                        <nz-input-group nzPrefix="Min:">
                          <input type="number" noScrollNumber nz-input formControlName="minValue" placeholder="Min value"
                            step="any" />
                        </nz-input-group>
                      </nz-form-control>
                    </nz-form-item>
                    <nz-form-item class="max-value-field">
                      <nz-form-control [nzValidateStatus]="displayVar.hasError('minMaxError') ? 'error' : ''"
                        [nzErrorTip]="displayVar.hasError('minMaxError') ? 'Max must be greater than min' : ''">
                        <nz-input-group nzPrefix="Max:">
                          <input type="number" noScrollNumber nz-input formControlName="maxValue" placeholder="Max value"
                            step="any" />
                        </nz-input-group>
                      </nz-form-control>
                    </nz-form-item>
                  }
                  <nz-form-item class="remove-button-field">
                    <button nz-button nzType="text" nzDanger nzSize="small" type="button"
                      (click)="removeDisplayVariable(i)" [disabled]="displayVariablesFormArray.length === 1">
                      <span nz-icon nzType="delete"></span>
                    </button>
                  </nz-form-item>
                </div>
              }

              @if (displayVariablesFormArray.length === 0) {
                <div class="no-display-variables">
                  <span>No display variables configured. Click "Add Model Type" to add one.</span>
                </div>
              }
            </div>
          </div>
        </nz-form-control>
      </nz-form-item>

      <div style="display: flex; justify-content: start; align-items: center; gap: 10px;">
        <button nz-button type="submit" nzType="primary">Update</button>

        @if (currentProject) {
          @if (!currentProject.archiveEnabled) {
            <button nz-button nz-popconfirm
              nzPopconfirmTitle="Are you sure you want to enable archiving for this project?"
            (nzOnConfirm)="enableArchiving()">Enable Archiving </button>
          } @else {
            <button nz-button nz-popconfirm nzDanger
              nzPopconfirmTitle="Are you sure you want to disable archiving for this project?"
            (nzOnConfirm)="disableArchiving()">Disable Archiving </button>
          }
        }

      </div>
    </form>
  </nz-spin>
</div>